module.exports = __webpack_public_path__ + "static/twl-Video-GFX-83cc2c2827df9039555faa73ec4c5a47.png";